import React, { useState, useContext, useEffect, useRef } from "react";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Spinner from "../components/Spinner.component";
import Compressor from "compressorjs";
import { FirebaseContext } from "../context/FirebaseContext";
import { encode } from "blurhash";
import OutlinedInput from "@mui/material/OutlinedInput";
import {
  addDoc,
  collection,
  getDocs,
  serverTimestamp,
  updateDoc,
  doc,
} from "firebase/firestore";
import { NavLink } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";

import DoneAllIcon from "@mui/icons-material/DoneAll";
import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import LinearProgress from "@mui/material/LinearProgress";

import Notify from "./Notify.component";
import CircularProgressWithLabel from "../components/CircularProgressWithLabel.component";

function AddEditProduct() {
  const location = useLocation();
  const navigate = useNavigate();
  const datas = location.state;
  const { name } = useParams();

  const { db, storage } = useContext(FirebaseContext);
  const categorieRef = collection(db, "categoriesProducts");
  const productsRef = collection(db, "products");

  const [edit, setEdit] = useState(false);
  const [file, setFile] = useState(null);
  const [compressedFile, setCompressedFile] = useState(null);
  const [categories, setCategories] = useState({});
  const [formData, setFormData] = useState({});
  const [progress, setProgress] = useState(20);
  const [state, setState] = useState("info");
  const [message, setMessage] = useState("En cours de traitement ...");
  const [error, setError] = useState(false);
  const [openStack, setOpenStack] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fetchData, setFetchData] = useState(true);
  const [failed, setFailed] = useState(false);
  const [hashImage, setHashImage] = useState("");
  const formRef = useRef(null);
  const imgRef = useRef(null);
  const getImageBlurhash = async (image, width, height) => {
    return new Promise((resolve) => {
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext("2d");

      const img = new Image();
      img.onload = () => {
        ctx.drawImage(img, 0, 0, width, height);

        const imageData = ctx.getImageData(0, 0, width, height);
        const blurhash = encode(
          imageData.data,
          imageData.width,
          imageData.height,
          4,
          3
        );
        resolve(blurhash);
      };
      img.src = URL.createObjectURL(image);
    });
  };
  function preview(e) {
    const image = e.target.files[0];
    if (!image) {
      return;
    }
    new Compressor(image, {
      quality: 0.1,
      success(compressedResult) {
        setCompressedFile(compressedResult);
      },
    });
    getImageBlurhash(image, 32, 32).then((hash) => {
      setHashImage(hash);
      setFile(
        e.target.files[0] ? URL.createObjectURL(e.target.files[0]) : null
      );
      console.log(hash);
    });
  }

  function handleChange(e) {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  }

  function resetParam() {
    setLoading(false);
    setTimeout(() => {
      setError(false);
      setState("info");
      setFailed(false);
    }, 4000);
  }
  function handleSubmit(e) {
    e.preventDefault();
    if (!compressedFile) {
      if (!edit) {
        setOpenStack(true);
      } else {
        setLoading(true);
        setMessage("Sauvegarde du produit modifier ...");
        const updateProd = async () => {
          await updateProduct(null)
            .then((r) => {
              onSucesss(r);
            })
            .catch((e) => {
              onCatch(e);
            })
            .finally(() => {
              onFinally();
              return;
            });
        };
        updateProd();
      }
      return;
    }
    setLoading(true);

    const pathId = !edit
      ? `imageVentes/${Date.now()}-${compressedFile?.name}`
      : datas["pathImgID"];
    const storageRef = ref(storage, pathId);

    const uploadTask = uploadBytesResumable(storageRef, compressedFile);

    // Listen for state changes, errors, and completion of the upload.
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progression =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setProgress(progression);
        switch (snapshot.state) {
          case "paused":
            setState("Warning");
            setMessage("Un petit instant");
            break;
          case "running":
            setState("info");
            setMessage("En cours de traitement");
            break;
          default:
            break;
        }
      },
      (error) => {
        switch (error.code) {
          case "storage/unauthorized":
          case "storage/canceled":
          case "storage/unknown":
          default:
            setState("error");
            setMessage("Un truc s'est mal passer, Reesayer");
            setError(true);
            setTimeout(() => {
              resetParam();
            }, 3000);

            break;
        }
      },
      () => {
        // Upload completed successfully, now we can get the download URL
        getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
          !edit
            ? setMessage("Sauvegarde du produit ...")
            : setMessage("Sauvegarde du produit modifier ...");
          if (!edit) {
            await addProduct(downloadURL, pathId)
              .then((r) => {
                onSucesss(r);
              })
              .catch((e) => {
                onCatch(e);
              })
              .finally(() => {
                onFinally();
              });
          } else {
            await updateProduct(downloadURL)
              .then((r) => {
                onSucesss(r);
              })
              .catch((e) => {
                onCatch(e);
              })
              .finally(() => {
                onFinally();
              });
          }
        });
      }
    );
  }
  function onSucesss(r) {
    setState("success");
    if (!edit) {
      setMessage("Produit Ajouter Avec Succès !");
    } else {
      setMessage("Produit Modifier Avec Succès !");
    }
    //console.log(r);
  }
  function onCatch(e) {
    setState("error");
    setFailed(true);
    if (!edit) {
      setMessage("Impossible de sauvegarder le produit");
    } else {
      setMessage("Impossible de Modifier le produit");
    }
    console.log(e);
  }
  function onFinally() {
    if (!edit) {
      if (!failed) {
        formRef.current?.reset();
        setCompressedFile(null);
        setFile(null);
      }
    }
    setTimeout(() => {
      resetParam();
    }, 3000);
  }
  const addProduct = async (res, path) => {
    await addDoc(productsRef, {
      pathStorageImage: path,
      imageProd: res,
      nameProd: formData["nameID"],
      categorieProd: formData["categorieID"],
      priceProd: formData["priceID"],
      descriptionProd: formData["descID"],
      imageHashProd: hashImage,
      timeStamp: serverTimestamp(),
    });
  };

  const updateProduct = async (res) => {
    const productsRefID = doc(db, "products", datas["id"]);
    if (res === null) {
      await updateDoc(productsRefID, {
        nameProd: formData["nameID"],
        categorieProd: formData["categorieID"],
        priceProd: formData["priceID"],
        descriptionProd: formData["descID"],
        timeStamp: serverTimestamp(),
      });
      return;
    }
    await updateDoc(productsRefID, {
      imageProd: res,
      nameProd: formData["nameID"],
      categorieProd: formData["categorieID"],
      priceProd: formData["priceID"],
      descriptionProd: formData["descID"],
      timeStamp: serverTimestamp(),
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const snapshot = await getDocs(categorieRef).then((snap) => {
          setFetchData(false);
          return snap;
        });
        const categoryData = {};

        snapshot.docs.forEach((doc) => {
          categoryData[doc.id] = doc.data();
        });
        setCategories(categoryData);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    if (location.pathname.split("/")[2] === "gestionVente") {
      if (datas === null) {
        navigate("/admin/gestionVente/");
      } else {
        setEdit(true);
        setFetchData(false);
        setFile(datas["img"]);
        //setCompressedFile(datas["img"]);
        setCategories(datas["categories"]);
        setFormData({
          nameID: datas["name"],
          categorieID: datas["categorieID"],
          priceID: datas["price"],
          descID: datas["desc"],
        });
      }
    }
  }, []);

  if (fetchData) {
    return <Spinner />;
  }
  if (!fetchData && Object.entries(categories).length === 0) {
    return (
      <div className="w-full h-full max-lg:h-[89vh] flex flex-col justify-center items-center text-center">
        <span>
          Pas de Categories enregistré, Veillez enregistrer un categorie de
          produit
        </span>
        <Button
          variant="contained"
          onClick={(e) => {
            e.preventDefault();
            navigate("/admin/gestionVente/categories");
          }}
          sx={{ display: "block", mt: "10px" }}
        >
          Ajouter un categorie
        </Button>
      </div>
    );
  }

  return (
    <>
      <h1 className="title">
        {edit ? "MODIFIER LE PRODUIT" : "AJOUT D'UN PRODUIT"}
      </h1>
      <hr />
      {edit && (
        <Breadcrumbs aria-label="breadcrumb">
          <NavLink to="/admin/gestionVente" className="hover:underline">
            Gestion Vente
          </NavLink>
          <Typography color="text.primary">
            {formData["nameID"] ?? name}
          </Typography>
        </Breadcrumbs>
      )}
      <label htmlFor="images" className="text-xs uppercase">
        Image du produit
      </label>
      <form
        className="flex w-full max-md:flex-col"
        onSubmit={handleSubmit}
        ref={formRef}
      >
        <div className="w-1/3 max-md:w-full">
          <div className="file_input">
            <input
              type="file"
              name="image"
              id="images"
              accept=".jpg,.png,.jpeg,.gif,.bmp,.svg,.ico"
              onChange={preview}
            />
            <img
              className={`img_ajout ${file && "hidden"}`}
              src={"/Images/icons/ajout_produit.png"}
              alt="ajout_image"
            />
            <img
              id="target_import"
              className={`${file ? "" : "hidden"}`}
              src={file}
              ref={imgRef}
              alt="TargetImage"
            />
            <img
              id="target_placeholder"
              className={`${file && "hidden"}`}
              src={"/Images/others/ImagePlaceholder.png"}
              alt="placeholder"
            />
          </div>
        </div>
        <div className="w-2/3 ml-5 flex flex-col space-y-3 max-md:w-full max-md:ml-0 max-md:my-5">
          <FormControl>
            <InputLabel id="categorie-label">Categorie</InputLabel>
            <Select
              required
              labelId="categorie-label"
              id="categorieID"
              name="categorieID"
              label="Categorie"
              onChange={handleChange}
              defaultValue={edit ? datas["categorieID"] : ""}
              MenuProps={{
                disableScrollLock: true,
              }}
            >
              {[...Object.entries(categories)].map((c) => (
                <MenuItem value={c[0]} key={c[0]}>
                  {c[1].name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            required
            id="nomProduct"
            label="Nom du Produit"
            name="nameID"
            defaultValue={edit ? datas["name"] : ""}
            onChange={handleChange}
          />
          <FormControl variant="outlined">
            <InputLabel
              id="prixProduct"
              sx={{ backgroundColor: "white", p: "0 0 10px 1px", m: 0 }}
            >
              Prix du produit *
            </InputLabel>
            <OutlinedInput
              required
              id="priceID"
              endAdornment={
                <InputAdornment position="end">FCFA</InputAdornment>
              }
              name="priceID"
              labelId="prixProduct"
              type="number"
              onChange={handleChange}
              defaultValue={edit ? datas["price"] : ""}
              inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
            />
          </FormControl>
          <TextField
            id="descProduct"
            label="Description du Produit"
            multiline
            rows={4}
            name="descID"
            defaultValue={edit ? datas["desc"] : ""}
            required
            onChange={handleChange}
          />
          <Box sx={{ position: "relative", width: "100%" }}>
            <Button
              variant="contained"
              disabled={loading}
              type="submit"
              className="w-full"
            >
              {edit ? "Modifier" : "Ajouter"}
            </Button>
            {loading && (
              <CircularProgress
                size={24}
                color="primary"
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-12px",
                  marginLeft: "-12px",
                }}
              />
            )}
          </Box>
        </div>
      </form>
      <Notify
        open={openStack}
        setOpen={setOpenStack}
        timing={3000}
        errorType={"error"}
      >
        Veillez choisir une image du produit
      </Notify>
      <Notify
        open={loading}
        setOpen={setLoading}
        timing={null}
        errorType={state}
        withIcon={false}
      >
        <div className="flex items-center space-x-3 text-White">
          {!error &&
          !failed &&
          state !== "success" &&
          compressedFile !== null ? (
            <CircularProgressWithLabel value={progress} />
          ) : (
            ""
          )}
          <div>
            {state === "success" && (
              <DoneAllIcon sx={{ color: "white", marginRight: "5px" }} />
            )}
            {message}
          </div>
        </div>
        {!error && !failed && state !== "success" && compressedFile !== null ? (
          <div className="absolute bottom-0 left-0 w-full">
            <LinearProgress variant="determinate" value={progress} />
          </div>
        ) : (
          ""
        )}
      </Notify>
    </>
  );
}

export default AddEditProduct;
/**
 
 */
